export default __webpack_public_path__ + "static/media/856.19f546e5.png";